import React, { useEffect, useState, Suspense } from "react";
import { Route, Routes, useLocation, useParams } from 'react-router-dom';
import Customize from './components/product/Customize';
import Blank from './components/support/blank';

import Checkout from './components/cart/ServerCheckout';
import { useSession } from './context/SessionContext';
import { useShoppingCart } from "context/ShoppingCartContext";
import { AdorsProvider } from "context/AdorsContext";


function App() {
  const { isLogin, loginSHA256, getProfile } = useSession();
  const location = useLocation();
  const [loggedIn, setLoggedIn] = useState(false);

  useEffect(() => {

    const credential = {
      "cid": "2177",
      "sid": "12345",
      "pcid": "2218",
      "pid": null,
      "uid": null,
      "fid": "1",
      "token": "cecbc0d6c7abb0dcb6f609d8ad6c0b09af1dc87da5ff042b373620ca97fdc4ec"
    }
    sessionStorage.setItem('profile', JSON.stringify(credential));

    // loginSHA256(location.search);
    setLoggedIn(isLogin());
  }, [loggedIn]);

  if (loggedIn) {
    const session = getProfile();

    return (
      <>
        <Suspense fallback={<div id="preloader">Loading ... </div>}>
          <AdorsProvider>
            <Routes>
              <Route path='*' element={session.fid == 2 ?
                <Checkout useSession={useSession} useShoppingCart={useShoppingCart} /> :
                <Customize useSession={useSession} useShoppingCart={useShoppingCart} />} />
            </Routes>
          </AdorsProvider>
        </Suspense>
      </>
    );
  } else {
    return (
      <div className="text-center">
        <Suspense fallback={<div id="preloader">Loading ... </div>}>
          <Routes>
            <Route path='*' element={<Blank />} />
          </Routes>
        </Suspense>
      </div>
    );
  }
}

export default App;

